import { gql } from '@apollo/client'

// Nested lists (`navigation_items`, `links`) are UNSORTED by default — the
// explicit `orderBy: { arrangement: asc }` is required, order is otherwise
// arbitrary.
export const GET_NAVIGATION_SETTINGS = gql`
  query GET_NAVIGATION_SETTINGS {
    findFirstShopSetting {
      id
      navigation_items(orderBy: { arrangement: asc }) {
        id
        arrangement
        type
        panel_source
        link_type
        link_page_id
        link_category_id
        link_collection_id
        external_url
        link_new_tab
        panel_root_category_id
        panel_root_page_id
        featured_page_id
        navigation_item_profiles {
          language
          label
        }
        links(orderBy: { arrangement: asc }) {
          id
          arrangement
          link_new_tab
          link_type
          link_page_id
          link_category_id
          link_collection_id
          external_url
          profiles {
            language
            label
          }
        }
      }
    }
  }
`

// Returns `[NavigationItem!]!` directly (non-null, unlike most of this
// codebase's mutations) — selects only `{ id }` so there's no unsorted list
// to accidentally normalize over the query's `orderBy`-sorted
// `navigation_items` cache entries. `refetchQueries` re-runs the real
// (sorted) query below instead of relying on this response.
export const UPDATE_NAVIGATION_SETTINGS = gql`
  mutation UPDATE_NAVIGATION_SETTINGS($items: [NavigationItemInput!]!) {
    updateNavigationSettings(items: $items) {
      id
    }
  }
`
